import React from 'react'
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';
import { FaGem, FaCrown, FaRegHandshake } from "react-icons/fa";

const AboutForHero = () => {

  const MotionNavLink = motion(NavLink);

  return (
    <div>
      {/* About Section */}
      <div className="about-section">
        <section className="container py-5">
          <div className="row align-items-center">

            {/* Left column with text + image */}
            <div className="col-lg-3 col-md-6 mb-4">
              <motion.div
                className="about-card text-center p-4 h-100 shadow-sm"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                <FaRegHandshake className="about-icon mb-3" />
                <p>
                  Since <strong>2002</strong>, <strong>JJ Associates</strong> has proudly represented
                  <strong> Tanishq</strong> — India’s most trusted jewellery brand from the
                  <strong> Tata Group</strong>.
                </p>
              </motion.div>

              <motion.img
                src="assets/imgs/img1.JPG"
                className="aboutimg2 mt-3"
                alt="Jewellery"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              />
            </div>

            {/* Middle column with image + card */}
            <div className="col-lg-3 col-md-6 mt-4">
              <motion.img
                src="/assets/imgs/img3.JPG" // replace with your video path
                className="aboutimg2 mb-2"
                initial={{ opacity: 0, }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.8 }}
              />

              <motion.div
                className="about-card text-center p-4 h-100 shadow-sm"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <FaGem className="about-icon mb-3" />
                <p>
                  For over two decades, we’ve brought <strong>craftsmanship</strong>,
                  <strong>purity</strong>, and <strong>elegance</strong> to Rajkot with
                  exquisite <em>gold, diamond,</em> and <em>platinum</em> creations for every occasion.
                </p>
              </motion.div>
            </div>

            {/* Right column with main description + button */}
            <div className="col-lg-6 text-center text-md-start">
              <motion.div
                className="p-4"
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                <h2 className="about-title mb-3">
                  A Legacy of Trust & Brilliance
                </h2>
                <p className="about-desc">
                  At <strong>JJ Associates</strong>, every jewel tells a story of excellence —
                  where artistry meets authenticity. We take pride in being Rajkot’s
                  trusted destination for jewellery that blends{" "}
                  <em>traditional Indian heritage</em> with <em>modern sophistication</em>.
                </p>
                <div className="mt-4">
                  <MotionNavLink
                    to="/about"
                    className="about-btn"
                    whileHover={{ scale: 1.05, backgroundColor: "#f3dac3", color: "#223831" }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Explore More →
                  </MotionNavLink>
                </div>
              </motion.div>
            </div>

          </div >
        </section >
      </div >
    </div>
  )
}

export default AboutForHero